export default __webpack_public_path__ + "static/voted-best-ballpark-75f669affcb2779e7e9862740c7f0973.jpg";